import { Link as RouterLink } from 'react-router-dom';
import { Link, Stack, Typography } from '@mui/material';
import HighlightedText from 'src/components/HighlightedText';
import StatusChip from 'src/components/StatusChip';
import { PORTAL_ROUTE } from 'src/constants/routes';

const LATEST_COLOR = '#7DFF92';
const SUBTEXT_SX = { color: '#D1D5DB', fontSize: '0.68rem', wordBreak: 'break-word' };
const HASH_SX = {
  fontFamily: 'monospace',
  fontSize: '0.65rem',
  color: '#9CA3AF',
  wordBreak: 'break-all',
};

// Latest is the newest version seen, whoever wrote it.
export const LatestChip = ({ version }) =>
  version.isLatest ? (
    <StatusChip
      label="Latest"
      color={LATEST_COLOR}
      backgroundColor={`${LATEST_COLOR}1F`}
      sx={{ height: 18, fontSize: '10px' }}
    />
  ) : null;

// A device-reported version is told apart from another build of the same version by this hash. A
// version the portal wrote has none, but neither does one from an agent that never sent a hash.
export const DetectedHash = ({ version, searchValue = '' }) =>
  version.policyHash ? (
    <Stack gap={0.25} sx={{ minWidth: 0 }}>
      <Typography component="span" sx={HASH_SX}>
        <HighlightedText text={version.policyHash} searchValue={searchValue} />
      </Typography>
      <Typography component="span" sx={SUBTEXT_SX}>
        {version.isSignedPolicy ? 'Signed' : 'Unsigned'}
      </Typography>
    </Stack>
  ) : (
    <Typography component="span" sx={SUBTEXT_SX}>
      No hash recorded; it may be portal managed.
    </Typography>
  );

// A policy can carry a long run of options, so they are set smaller than the text around them.
export const RuleOptionsList = ({ ruleOptions, fallback = '—' }) =>
  ruleOptions?.length ? (
    <ul
      style={{ listStyleType: 'none', margin: 0, padding: 0, fontSize: '0.6rem', lineHeight: 1.4 }}>
      {ruleOptions.map(option => (
        <li key={option}>- {option}</li>
      ))}
    </ul>
  ) : (
    fallback
  );

export const BasePolicyLink = ({ version }) =>
  version.baseEnvPolicyId ? (
    <Link
      component={RouterLink}
      to={`${PORTAL_ROUTE}/policy-details/${version.baseEnvPolicyId}/general`}
      underline="hover"
      sx={{ color: '#87C8E0' }}>
      {version.basePolicyName || version.basePolicyId}
    </Link>
  ) : (
    '-'
  );
